import "./styles.css";

export default function Display(props) {
  let { data, isFetched, darkMode } = props;

  return (
    <>
      {isFetched ? (
        <div className={darkMode ? "gif-container-dark" : "gif-container"}>
          {data.data.map((object) => (
            <img
              className="gif"
              width="32%"
              src={object.images.original.url}
              alt="failed to load gif"
              key={object.slug}
            />
          ))}
        </div>
      ) : (
        <div>Cargando...</div>
      )}
    </>
  );
}
